/**
 * Scriptures for lesson teacher-2 (reverence and service). Text from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const teacher2TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-121-43-44',
    reference: 'Doctrine and Covenants 121:43–44',
    text:
      'Reproving betimes with sharpness, when moved upon by the Holy Ghost; and then showing forth afterwards an increase of love toward him whom thou hast reproved, lest he esteem thee to be his enemy; That he may know that thy faithfulness is stronger than the cords of death.',
    verses: [
      {
        verse: 43,
        text: 'Reproving betimes with sharpness, when moved upon by the Holy Ghost; and then showing forth afterwards an increase of love toward him whom thou hast reproved, lest he esteem thee to be his enemy;',
      },
      {
        verse: 44,
        text: 'That he may know that thy faithfulness is stronger than the cords of death.',
      },
    ],
    context: 'Reproof by the Spirit, then increased love.',
  },
  {
    id: 'dc-20-53-54',
    reference: 'Doctrine and Covenants 20:53–54',
    text:
      'The teacher’s duty is to watch over the church always, and be with and strengthen them; And see that there is no iniquity in the church, neither hardness with each other, neither lying, backbiting, nor evil speaking;',
    verses: [
      {
        verse: 53,
        text: 'The teacher’s duty is to watch over the church always, and be with and strengthen them;',
      },
      {
        verse: 54,
        text: 'And see that there is no iniquity in the church, neither hardness with each other, neither lying, backbiting, nor evil speaking;',
      },
    ],
    context: 'Watch, strengthen, and preserve unity and charity in the ward.',
  },
  {
    id: 'matthew-5-16',
    reference: 'Matthew 5:16',
    text: 'Let your light so shine before men, that they may see your good works, and glorify your Father which is in heaven.',
    verses: [
      {
        verse: 16,
        text: 'Let your light so shine before men, that they may see your good works, and glorify your Father which is in heaven.',
      },
    ],
    context: 'Good works that glorify the Father.',
  },
  {
    id: 'philippians-2-3-4',
    reference: 'Philippians 2:3–4',
    text:
      'Let nothing be done through strife or vainglory; but in lowliness of mind let each esteem other better than themselves. Look not every man on his own things, but every man also on the things of others.',
    verses: [
      {
        verse: 3,
        text: 'Let nothing be done through strife or vainglory; but in lowliness of mind let each esteem other better than themselves.',
      },
      {
        verse: 4,
        text: 'Look not every man on his own things, but every man also on the things of others.',
      },
    ],
    context: 'Lowliness of mind and care for others.',
  },
];
